<template>
  <fin-selectable-card
    v-on="$listeners.click ? {click: (e) => $emit('click', e)} : {}"
    v-bind="cardOptions"
    :no-border="contentOnly"
    @click.native="$emit('cardClicked')"
    :class="(contentOnly ? ' px-2 py-6' : ' px-3 py-4')"
    :style="contentOnly ? 'border: 0px; box-shadow: none' : ''"
    inlist>

    <v-row v-if="mode === 'titleFirst'" v-style:opacity="inactive ? 0.5 : 1" class="mb-1">
      <v-col class="pb-3" cols="12">
        <p class="card-title mb-0">
          <slot name="title"/>
        </p>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <v-col v-style:opacity="inactive ? 0.5 : 1"
                 :md="mode === 'titleFirst' || !$slots['small-chart-actions'] ? 3 : 2"
                 cols="3">
            <slot name="chart"/>
          </v-col>
          <v-col v-style:opacity="inactive ? 0.5 : 1"
                 :lg="!$slots['small-chart-actions'] || mode === 'titleFirst' ? 9 : 8"
                 :md="!$slots['small-chart-actions'] || mode === 'titleFirst' ? 9 : 7"
                 cols="9">
            <v-row v-if="mode !== 'titleFirst'" no-gutters>
              <v-col class="pa-0">
                <div class="card-title mb-2">
                  <slot name="title"/>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-0"
                     :cols="mode === 'titleFirst' ? 12 : 'auto'">
                <div class="card-value1 mb-0">
                  <slot name="value1"/>
                </div>
              </v-col>
              <v-spacer style="max-width: 100px"/>
              <v-col class="pa-0"
                     :cols="mode === 'titleFirst' ? 12 : 'auto'">
                <div class="card-value2 mb-0">
                  <slot name="value2"/>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="$slots['small-chart-actions']" :lg="mode === 'titleFirst' ? 12 : 2"
                 :md="mode === 'titleFirst' ? 12 : 3"
                 align="right"
                 cols="12">
            <slot name="small-chart-actions"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </fin-selectable-card>
</template>

<script>
import FinSelectableCard from "@/components/common/Chart2/PerformanceCharts/SelectableCard"

export default {
  name: 'FinSmallCard',
  components: {FinSelectableCard},
  props: {
    /* available values: 'default' and 'titleFirst' */
    mode: {
      type: String,
      default: 'default'
    },
    contentOnly: {
      type: Boolean,
      default: false
    },
    cardOptions: {
      type: Object
    },
    inactive: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../styles/variables";

.card-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-value1 {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
}

.card-value2 {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
}

.chart-col {
  max-width: 60px;
  width: 60px;
  height: 40px;
  max-height: 40px;
}
</style>
